/**
*   Created by FANGlh on 2018/11/14 17:36.
*   Desc:
*/

import React,{Component} from 'react';
import './ResApply.css';
import delete_img from '../../../style/imgs/delete.png';
import {Icon} from 'antd';
import {Toast} from 'antd-mobile';


export default class UserItem extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <div onChange={this.handelValueCom}>
                <div style={{display:'flex',flexDirection:'row',backgroundColor:'#F2F2F2'}}>
                    <div className="res_detail">物品明细({this.props.index+1})</div>
                    {this.props.index != 0 ?  <div>
                        <Icon type="minus-circle" alt="" style={{height:20,width:20,marginRight:20,color: '#ff0a0a'}} onClick={this.deleteItem.bind(this,this.props.index)}/>
                    </div> : ''}
                </div>
                <div className="item_sty">
                    <div className="left_title">物品名称</div>
                    <input  ref='itemuser'  className="text-right right_input" type="text" placeholder="请输入"  maxLength={20} value={this.props.itemata.artName} />
                </div>
                <div className="comhline_sty1"></div>
                <div className="item_sty">
                    <div className="left_title">数量</div>
                    <input   ref='itemnumber' className="text-right right_input" type="number" placeholder="请输入" maxLength={6} value={this.props.itemata.artCount} />
                </div>
                <div className="comhline_sty1"></div>
            </div>
        )
    }
    deleteItem =(index)=> {
        console.log('index',index)
        this.props.removeSItem(this.props.index)
    }
    handelValueCom = (event)=>{
        //请输入选项内容
        let itemuser = this.refs.itemuser.value;
        let itemnumber = this.refs.itemnumber.value;
        console.log('itemuser',itemuser)
        console.log('itemnumber',itemnumber)
        console.log('itemnumber%1 === 0',itemnumber%1 == 0)
        if(itemnumber.length > 0){
            if(itemnumber%1 == 0 && itemnumber > 0){
                if(itemnumber.length > 6){
                    Toast.show('可申请数量有限',1)
                    this.props.handelRItem({
                        artName:itemuser,
                        artCount:''
                    },this.props.index)
                    return
                }
                this.props.handelRItem({
                    artName:itemuser,
                    artCount:itemnumber
                },this.props.index)
            }else {
                Toast.show('请输入正整数',1)
                this.props.handelRItem({
                    artName:itemuser,
                    artCount:''
                },this.props.index)
                return
            }
        }
    }
}